'use client';

import * as React from 'react';

var JobFitIcon = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 48 : _b, _c = _a.height, height = _c === void 0 ? 48 : _c;
    return (React.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 48 48', fill: 'none' },
        React.createElement("path", { opacity: 0.21, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M0 24v1c0 12.703 10.298 23 23 23h2c12.703 0 23-10.297 23-23v-2C48 10.298 37.703 0 25 0h-2C10.298 0 0 10.298 0 23z', fill: '#FEC53D' }),
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'm12 19.453 10.32 5.959q.168.095.347.14v11.556l-9.93-5.877A1.5 1.5 0 0 1 12 29.94zm24.003-.158V29.94a1.5 1.5 0 0 1-.736 1.291l-9.931 5.877V25.45l.072-.04z', fill: '#FEC53D' }),
        React.createElement("path", { opacity: 0.499, fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12.328 16.562c.126-.16.285-.294.47-.393l10.5-5.593a1.5 1.5 0 0 1 1.411 0l10.5 5.593a1.5 1.5 0 0 1 .379.287l-11.512 6.647a1.4 1.4 0 0 0-.21.149 1.4 1.4 0 0 0-.208-.15z', fill: '#FEC53D' })));
};

export { JobFitIcon as default };
//# sourceMappingURL=JobFitIcon.js.map
